import { includes } from "./utils/includes.js";
import { unsafeKeys } from "./utils/utility-functions.js";
import { StringEnum } from "@feathersjs/typebox";
export const artccLetterMap = {
    KZAB: "A",
    KZNY: "N",
    KZDC: "W",
    KZBW: "B",
    KZOB: "C",
    KZJX: "J",
    KZTL: "T",
    KZHU: "H",
    KZMA: "R",
    KZME: "M",
    KZAU: "G",
    KZDV: "D",
    KZMP: "P",
    KZLA: "L",
    KZKC: "K",
    KZID: "I",
    KZOA: "O",
    KZFW: "F",
    KZLC: "U",
    KZSE: "S",
};
export const artccList = unsafeKeys(artccLetterMap);
export const artccIdSchema = StringEnum(artccList);
export const artccListWithAll = ["ALL", ...artccList];
export function isArtccId(id) {
    return typeof id === "string" && includes(artccList, id);
}
export const MAX_ALTIMETER_LIST_LENGTH = 24;
export const sectorServerEventNames = [
    "getFrd",
    "updateEdstFp",
    "deleteEdstFp",
    "addTrialPlan",
    "trialPlanCleanup",
    "removePointout",
    "setCfrIsOpen",
    "setDwellLocked",
    "setLine4Override",
    "setFdbLdr",
    "toggleLdb",
    "removeAllCfrAircraft",
    "setCrrColor",
    "removeCrrGroup",
    "removeAllCrrAircraftInGroup",
    "setAclSortMethod",
    "toggleAclPostingMode",
    "setDepSortMethod",
    "toggleDepPostingMode",
    "promptReliefResponse",
    "setSectorSaaDisplay",
    "acknowledgeCpdlcDialogStatus",
    "deleteCpdlcDialogs",
    "cancelUplinkDialog",
    "cleanupTocAndRelease",
    "sendPidDialogResponse",
    "addSaaActivation",
    "removeSaaActivation",
    "updateSaaActivation",
    "setSaaForcedOff",
];
export function getFpInSectorTime(favCrossings, artccId, ownedFavs) {
    if (ownedFavs.length === 0) {
        return { minTime: 0, maxTime: 0 };
    }
    return favCrossings.reduce((acc, crossing) => {
        if (ownedFavs.some((favId) => crossing.favModuleId.startsWith(`${artccId}-${favId}`))) {
            acc.minTime = Math.min(acc.minTime === 0 ? Infinity : acc.minTime, crossing.entryTime);
            acc.maxTime = Math.max(acc.maxTime, crossing.exitTime);
        }
        return acc;
    }, { minTime: 0, maxTime: 0 });
}
//# sourceMappingURL=events.js.map